// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RjjC","label":"styles_label__3thb7"};